export const getTotalNotesIndicator = totalLabel => ({
  name: totalLabel,
  key: 'total',
});
